import { HoneycombCategoricalLegendRenderer } from './HoneycombCategoricalLegendRenderer.js';
import { HoneycombRangeLegendRenderer } from './HoneycombRangeLegendRenderer.js';
import { useHoneycombDatasetType } from '../../hooks/use-honeycomb-dataset-type.js';
import { useHoneycombLegendConfig } from '../../hooks/use-honeycomb-legend-config.js';

const HONEYCOMB_LEGEND_RENDERERS = {
  numeric: <HoneycombRangeLegendRenderer />,
  categorical: <HoneycombCategoricalLegendRenderer />,
};

export const HoneycombLegendRenderer = () => {
  const legend = useHoneycombLegendConfig();
  const datasetType = useHoneycombDatasetType();

  if (!legend) {
    return null;
  }

  return HONEYCOMB_LEGEND_RENDERERS[datasetType];
};
